define.alias("shared/utils/can-create-linkinbio-page", "settings/utils/can-create-linkinbio-page");